// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.tabs__bar {
    position: relative;
    z-index: 1001;
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    background-color: var(--color-bg-2);
    border-bottom: 1px solid var(--color-border);
}

.tabs__tab_list {
    display: flex;
    flex-direction: row;
    flex: 1;
    min-width: 0;
    overflow-x: auto;
    scrollbar-width: none;
}

.tabs__tab_list::-webkit-scrollbar {
    display: none;
}

.tabs__tab {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 18px;
    height: 38px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    color: var(--color-text-muted);
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    transition: color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .tabs__tab:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.tabs__tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent);
}

.tabs__tab.drag-over {
    box-shadow: inset 2px 0 0 var(--color-accent);
    background-color: var(--color-bg-3);
}

.tabs__tab_label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tabs__tab_close {
    flex-shrink: 0;
    margin-left: 7px;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    font-size: 15px;
    line-height: 1;
    opacity: 0;
    transition: opacity 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .tabs__tab:hover .tabs__tab_close,
    .tabs__tab.active .tabs__tab_close {
        opacity: 0.6;
    }
}

@media (pointer: fine) {
    .tabs__tab_close:hover {
        opacity: 1 !important;
        background-color: var(--color-bg-3);
    }
}

@media (pointer: coarse) {
    .tabs__tab_close {
        opacity: 0.6;
    }
}

.tabs__content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/Tabs/s.tabs.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mCAAmC;IACnC,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;IAC7C,mCAAmC;AACvC;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,OAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".tabs {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.tabs__bar {\n    position: relative;\n    z-index: 1001;\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    background-color: var(--color-bg-2);\n    border-bottom: 1px solid var(--color-border);\n}\n\n.tabs__tab_list {\n    display: flex;\n    flex-direction: row;\n    flex: 1;\n    min-width: 0;\n    overflow-x: auto;\n    scrollbar-width: none;\n}\n\n.tabs__tab_list::-webkit-scrollbar {\n    display: none;\n}\n\n.tabs__tab {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    padding: 0 18px;\n    height: 38px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: var(--color-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n    white-space: nowrap;\n    user-select: none;\n    transition: color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .tabs__tab:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.tabs__tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent);\n}\n\n.tabs__tab.drag-over {\n    box-shadow: inset 2px 0 0 var(--color-accent);\n    background-color: var(--color-bg-3);\n}\n\n.tabs__tab_label {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.tabs__tab_close {\n    flex-shrink: 0;\n    margin-left: 7px;\n    width: 15px;\n    height: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1;\n    opacity: 0;\n    transition: opacity 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .tabs__tab:hover .tabs__tab_close,\n    .tabs__tab.active .tabs__tab_close {\n        opacity: 0.6;\n    }\n}\n\n@media (pointer: fine) {\n    .tabs__tab_close:hover {\n        opacity: 1 !important;\n        background-color: var(--color-bg-3);\n    }\n}\n\n@media (pointer: coarse) {\n    .tabs__tab_close {\n        opacity: 0.6;\n    }\n}\n\n.tabs__content {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
